export const parameters = {
	serviceUrl: 'https://briisk-i-uat-api.azure-api.net/bl',
	captchaKey: '6LeeTsMrAAAAANEOVxC4fMXdXZX2yzABk9SdvhsA',
	brandLabelSubscriptionKey: 'c39f3e284f68434e93a0dfdf0eb6b867',
	bitpUrl: 'https://briisk-i-uat-web.azurewebsites.net',
	environment: '',
	appInsightsConnectionString: 'InstrumentationKey=afdaeae2-dc79-491d-ab8c-696189e8cb43;IngestionEndpoint=https://southafricanorth-0.in.applicationinsights.azure.com/;LiveEndpoint=https://southafricanorth.livediagnostics.monitor.azure.com/;ApplicationId=0b93ea63-4f6c-46ce-91f4-9bc0366a53e6'

	// serviceUrl: 'http://localhost:7071',
	// serviceUrl: 'https://briisk-i-dev-api.azure-api.net/bl',
	// captchaKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
	// brandLabelSubscriptionKey: '6aeeca623d274b61bd75b25cd28d2cb8',
	// bitpUrl: 'https://briisk-i-dev-web.azurewebsites.net',
	// environment: 'dev',
	// appInsightsConnectionString: ''
};
